'use client'

import { cn } from '@mntn-dev/ui-utilities'
import { BladeCommon, type BladeCommonProps } from '../blade-common.tsx'

export type ServiceBladeProps = BladeCommonProps & {}

export const ServiceBlade = ({
  children,
  className,
  ...props
}: ServiceBladeProps) => {
  return (
    <BladeCommon className={cn('min-h-14 gap-4', className)} {...props}>
      {children}
    </BladeCommon>
  )
}
